import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../../Shared/Loader';
import { useRef } from 'react';
import AddPurchaseProductList from './AddPurchaseProductList';
import AddPurchaseInvoice from './AddPurchaseInvoice';
import { addUpdateDetails, selectSupplier } from '../../../../../../features/PurchaseSlice/PurchaseSlice';
import SupplierList from '../../../../../../hooks/SupplierList';


const UpdatePurchaseReturnInvoice = () => {
    const { posSupplier, isSupplier } = useSelector((state) => state.purchaseInvoice);
    const supply = useSelector((state) => state.purchaseInvoice.supplier);
    const [isSearching, setIsSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [loading, setLoading] = useState(true);
    const [suppliers, setSuppliers] = useState([]);
    // const [details, setDetails] = useState();
    const [defaultSupplier, setDefaultSupplier] = useState(false);
    const [isChangeDate, setIsChangeDate] = useState(false);

    const { editReturnPurchase } = useSelector((state) => state.purchaseInvoice);

    console.log(editReturnPurchase);

    const supplierCodeRef = useRef('');
    const supplierRef = useRef('');
    const dateRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');
    const invoiceRef = useRef('');

    const dispatch = useDispatch();



    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsuppliers')
            .then(res => res.json())
            .then(data => {
                setSuppliers(data);
                setLoading(false)
            })
    }, [])


    if (loading) {
        return <Loader />
    }

    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = suppliers.filter(supplier => supplier.name.includes(searchText)
            || supplier.name.toLowerCase().includes(searchText) ||
            supplier.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleSelectSupplier = (suppliar) => {
        dispatch(selectSupplier(suppliar))
        setIsSearching(false)
        setSearchText('');
        setDefaultSupplier(true)

        setTimeout(() => { handlePurchaseDetails() }, 2000);
        // const purchaseInvoice = invoiceRef.current.value;
        // const purchaseSupplier = supplierRef.current.innerText;
        // const purchaseAddress = addressRef.current.innerText;
        // const purchasePhone = phoneRef.current.innerText;
        // const purchaseOpening = openingRef.current.innerText;
        // const purchaseDate = dateRef.current.value;
        // dispatch(addUpdateDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate }))

    }


    const handlePurchaseDetails = (event) => {
        const purchaseInvoice = invoiceRef.current.value;
        const supplierCode = supplierCodeRef.current.innerText;
        const purchaseSupplier = supplierRef.current.innerText;
        const purchaseAddress = addressRef.current.innerText;
        const purchasePhone = phoneRef.current.innerText;
        const purchaseOpening = openingRef.current.innerText;
        const purchaseReturnDate = dateRef.current.value;
        // setDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate })
        dispatch(addUpdateDetails({ purchaseInvoice, supplierCode, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseReturnDate }))
        setIsChangeDate(true);
    }


    return (
        <div>
            <div className='w-full px-5 pb-5 my-5 text-xs'>
                <h1 className='text-lg text-center bg-primary p-3 text-white rounded-xl'>Update Return Purchase</h1>
                <div className='grid grid-cols-1 lg:grid-cols-12 gap-px'>
                    <div className='lg:col-span-4 mt-4'>
                        <table class="table w-1/2 mx-auto">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Select Date</th>
                                    <th className='bg-primary text-white normal-case'>Invoice No</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td><input onChange={handlePurchaseDetails} ref={dateRef} type="date" defaultValue={editReturnPurchase?.purchaseReturnDate} className='rounded-lg bg-gray-200 p-3  text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                    <td><input onChange={handlePurchaseDetails} ref={invoiceRef} type="text" defaultValue={editReturnPurchase?.purchaseInvoice} className='rounded-lg bg-gray-200 p-3 w-40 text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    {/* <div class="form-control w-full lg:w-60 max-w-xs mt-5 col-span-2">
                        <div class="form-control lg:w-60 mx-auto">
                            {/* <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Supplier" class="rounded-lg bg-gray-300 text-textPrimary p-3 text-white text-center focus:border-blue-500 focus:outline-none w-full max-w-xs" />
                        </div>
                        <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isSearching ? 'h-16' : "h-8"} w-80 overflow-auto`}>
                            {
                                isSearching ? searchResult.map(supplier =>
                                    <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>) :
                                    suppliers.map(supplier =>
                                        <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>)
                            } */}
                    {/* <SupplierList handlePurchaseDetails={handlePurchaseDetails} suppliers={suppliers} /> */}
                    {/* </div> */}
                    {/* </div> */}
                    <div className='lg:col-span-6 mt-4 overflow-auto lg:lg:overflow-visible'>
                        <table class="table lg:w-1/2 lg:ml-2">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Supplier Code</th>
                                    <th className='bg-primary text-white normal-case'>Supplier Name</th>
                                    <th className='bg-primary text-white normal-case'>Supplier Address</th>
                                    <th className='bg-primary text-white normal-case'>Mobile No</th>
                                    <th className='bg-primary text-white normal-case'>Previews Due</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td ref={supplierCodeRef}>{isSupplier === true ? posSupplier?.code : editReturnPurchase?.supplierCode}</td>
                                    <td onChange={handlePurchaseDetails} ref={supplierRef} className='h-8'>{isSupplier === true ? posSupplier?.name : editReturnPurchase?.purchaseSupplier}</td>
                                    <td ref={addressRef}>{isSupplier === true ? posSupplier?.address : editReturnPurchase?.purchaseAddress}</td>
                                    <td ref={phoneRef}>{isSupplier === true ? posSupplier?.phone : editReturnPurchase?.purchasePhone}</td>
                                    <td ref={openingRef}>{isSupplier === true ? posSupplier?.opening : editReturnPurchase?.purchaseOpening}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <br />
                </div>
                <div className='grid grid-cols-1 relative'>
                    <AddPurchaseProductList />
                    <AddPurchaseInvoice isChangeDate={isChangeDate} />
                </div>
            </div>
        </div>
    );
};

export default UpdatePurchaseReturnInvoice;